export default "__VITE_ASSET__DF8TDBNR__"